import React from 'react'
import PropTypes from 'prop-types'

import { Flex } from '@chatterbug/aaron'
import ToggleButton from 'src/ui/ToggleButton/ToggleButton'
import { t } from 'src/lib/i18n-react'

import UnitInfo from '../UnitInfo/UnitInfo'

const UnitHeader = ({ unit, inCourse, onToggleInCourse }) => {
  return (
    <UnitInfo unit={unit}>
      {unit.isElective && !unit.progress?.isCompleted && (
        <Flex
          mt={{ _: '3x', tablet: '2x' }}
          justifyContent={{ _: 'center', tablet: 'flex-start' }}
          alignItems="flex-start"
        >
          <ToggleButton
            icon="bookmark"
            checked={inCourse}
            labelCheck={t('Add to course')}
            labelUncheck={t('Remove from course')}
            onToggle={onToggleInCourse}
          />
        </Flex>
      )}
    </UnitInfo>
  )
}

UnitHeader.propTypes = {
  unit: PropTypes.shape({
    name: PropTypes.string.isRequired,
    iconUrl: PropTypes.string,
    isElective: PropTypes.bool,
    progress: PropTypes.shape({
      isCompleted: PropTypes.bool,
    }),
  }),
  inCourse: PropTypes.bool.isRequired,
  onToggleInCourse: PropTypes.func.isRequired,
}

export default UnitHeader
